import { HStack, Heading } from "@chakra-ui/react";
import React from "react";
import IButton from "../../../../../../components/IButton";
import ValidationStateIndicator from "./ValidationStateIndicator";

export default function SectionTitle({
  readonly,
  btnRef,
  onOpen,
  active,
  activeErrorCheck,
  errorText,
  title,
}: {
  readonly: boolean;
  btnRef: React.MutableRefObject<any>;
  onOpen: () => void;
  active: boolean;
  activeErrorCheck: boolean;
  errorText: string;
  title: string;
}) {
  return (
    <HStack alignItems="baseline">
      <Heading fontSize="sm">{title}</Heading>
      {readonly ? (
        <IButton
          variant="link"
          color="brandBlue.400"
          ref={btnRef.current}
          onClick={onOpen}
        >
          View
        </IButton>
      ) : (
        <IButton
          variant="link"
          color="brandBlue.400"
          ref={btnRef.current}
          onClick={onOpen}
        >
          Edit
        </IButton>
      )}
      <ValidationStateIndicator
        show={!active && activeErrorCheck}
        errorText={errorText}
      />
    </HStack>
  );
}
